import { LandingEliteVillasPage } from '@/lib/pages/landing-sale-elite-villas';

import { ILandingVillasPage } from '@/lib/entities/page';
import { getOwnEliteVillasData } from '@/lib/entities/sale/lib';
import { fetchPageSeo, PageSeo } from '@/lib/entities/seo';
import { SeoEntries } from '@/lib/entities/seo/lib/seo-entries';
import { getSocialData } from '@/lib/entities/social';

import { isDevelopment } from '@/lib/config';
import { GetStaticProps } from 'next';
import { i18n, useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

interface IProps {
  data: ILandingVillasPage;
  pageSeo: PageSeo | null;
}
export default function LandingVillas({ data, pageSeo }: IProps) {
  const {
    t,
    i18n: { language },
  } = useTranslation('index', { keyPrefix: 'meta' });
  return (
    <>
      <SeoEntries
        fallback={{
          title: t('landingVillas.title'),
          description: t('landingVillas.description'),
          openGraphImage: '/images/og.png',
        }}
        seo={pageSeo}
        language={language}
        path="/sale/elitevillas/phuket"
        noFollow
      />

      <main>
        <LandingEliteVillasPage data={data} h1={pageSeo?.h1} />
      </main>
    </>
  );
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  if (locale === 'default') {
    return {
      notFound: true,
    };
  }
  const villas = await getOwnEliteVillasData(locale || 'ru');
  const socialsData = await getSocialData(locale ?? 'ru');
  const data: ILandingVillasPage = { ...socialsData, villas };
  if (isDevelopment) {
    await i18n?.reloadResources();
  }
  const pageSeo = await fetchPageSeo({
    path: '/sale/elitevillas/phuket',
    language: locale || 'ru',
  });
  return {
    props: {
      ...(await serverSideTranslations(locale ?? 'ru', ['index'])),
      data,
      headerTheme: 'light',
      pageSeo,
    },
    revalidate: 360,
  };
};
